import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  ctaTitle: {
    id: 'catalog.home.cta.title',
    defaultMessage: 'Ready to accelerate your career?',
    description: 'Landing page CTA title.',
  },
  ctaDescription: {
    id: 'catalog.home.cta.description',
    defaultMessage: 'Create your free account and start learning today with WutiSkill.',
    description: 'Landing page CTA description.',
  },
  ctaButton: {
    id: 'catalog.home.cta.button',
    defaultMessage: 'Create a free account',
    description: 'Landing page CTA button label.',
  },
});

export default messages;
